import { Component, OnInit, Optional, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { DSM34_DIALOG_DATA, DSM34DialogRef } from '@eredes/dsm34';

import { EdpValidators } from '../../_shared/edp-validators/edp-validators';
import { RequestService } from '../request.service';

@Component({
  selector: 'app-request-modal',
  templateUrl: './request-modal.component.html',
  standalone: false,
})
export class RequestModalComponent implements OnInit {
  changeTypeFormData: any;
  changeStatusFormData: any;
  changeUserFormData: any;
  reOpenFormData: any;

  modalTitle: string;
  modalText: string;
  btnCancelText: string;
  btnConfirmText: string;
  confirmEvent: any;
  closeEvent: any;
  changeType = false;
  changeStatus = false;
  changeUser = false;
  reOpen = false;
  openListAttachments = false;
  infoDetail: any;

  voltageLevelRequired = false;
  voltageLevelList: any = [];
  dynamicList: any = [];
  showVoltageField = false;

  allAreas: any;
  allTypes1: any;
  allTypes2: any;
  allStatus: any;
  attachList: any;

  defaultAreaId: string;
  defaultType1Id: string;
  defaultType2Id: string;
  defaultStatus: string;
  defaultStatusId: string;
  defaultvoltageLevelId: string;

  notesLabel = 'Resposta';
  notesPlaceholder = 'a sua resposta';

  changeTypeRequestForm: UntypedFormGroup;
  changeStatusRequestForm: UntypedFormGroup;
  reOpenRequestForm: UntypedFormGroup;

  showAttachments = true;
  fileList: any[] = [];
  fileName: string;
  fileContent: string;
  fileSize: number;
  fileTooLarge: boolean;
  attachmentsList: any[] = [];

  get ft() {
    return this.changeTypeRequestForm.controls;
  }

  get fs() {
    return this.changeStatusRequestForm.controls;
  }

  get fr() {
    return this.reOpenRequestForm.controls;
  }

  constructor(
    @Optional()
    @Inject(DSM34_DIALOG_DATA)
    public data: any,
    private readonly dialogRef: DSM34DialogRef<RequestModalComponent>,
    private readonly fb: UntypedFormBuilder,
    protected requestService: RequestService
  ) {}

  ngOnInit() {
    this.modalTitle = this.data.modalTitle;
    this.modalText = this.data.modalText;
    this.btnConfirmText = this.data.btnConfirmText;
    this.btnCancelText = this.data.btnCancelText;
    this.infoDetail = this.data.infoDetail;
    this.confirmEvent = this.data.confirmEvent || true;
    this.closeEvent = this.data.closeEvent || false;

    this.changeType = this.data.changeType || false;
    this.changeStatus = this.data.changeStatus || false;
    this.changeUser = this.data.changeUser || false;
    this.reOpen = this.data.reOpen || false;
    this.openListAttachments = this.data.openListAttachments || false;

    this.defaultAreaId = this.infoDetail.requestAreaUniqueCode;
    this.defaultType1Id = this.infoDetail.requestTypeUniqueCode;
    this.defaultType2Id = this.infoDetail.requestSubTypeUniqueCode;

    this.defaultvoltageLevelId = this.infoDetail.voltageLevelUniqueCode;

    this.defaultStatus = this.infoDetail.statusTitle;
    this.defaultStatusId = this.infoDetail.statusUniqueCode;
    this.allStatus = this.data.allStatus;

    this.initForms(this.infoDetail);
    this.checkDefaultValues();
    this.getAttachmentsList(this.infoDetail.commentUniqueCode);
  }

  // GET ATTACHMENT LIST & DOWNLOAD FILE
  getAttachmentsList(commentUniqueCode) {
    if (commentUniqueCode) {
      this.requestService
        .getCommentAttachments(commentUniqueCode)
        .subscribe((data) => (this.attachList = data.Result.Collection));
    }
  }

  downloadFile(file: any) {
    this.requestService.downloadAttachment(file.fileId).subscribe(
      (data) => {},
      (err) => {
        console.error(`error : ${err.error}`);
      }
    );
  }

  initForms(info) {
    if (this.changeType) {
      this.initAreaList(info.requestOperationTypeUniqueCode);
      this.initType1List(info.requestAreaUniqueCode);
      this.initType2List(info.requestTypeUniqueCode);

      this.changeTypeRequestForm = this.fb.group({
        area: [info.requestAreaUniqueCode],
        type1: [info.requestTypeUniqueCode],
        type2: [info.requestSubTypeUniqueCode],
        voltage: [info.voltageLevelUniqueCode],
        notes: ['', [EdpValidators.required]],
      });
    } else if (this.changeStatus) {
      this.changeStatusRequestForm = this.fb.group({
        status: [info.statusUniqueCode, [EdpValidators.required]],
        notes: ['', [EdpValidators.required]],
        files: [''],
      });
    } else if (this.reOpen) {
      this.reOpenRequestForm = this.fb.group({
        notes: ['', [EdpValidators.required]],
      });
    }
  }

  initAreaList(info) {
    this.requestService.getOperationChildren(info).subscribe((data) => (this.allAreas = data.Result.Collection));
  }

  initType1List(info) {
    this.requestService.getOperationChildren(info).subscribe((data) => (this.allTypes1 = data.Result.Collection));
  }

  initType2List(info) {
    this.requestService.getOperationChildren(info).subscribe((data) => (this.allTypes2 = data.Result.Collection));
  }

  changeTypeFunction(operation, field) {
    if (field === 'area') {
      this.allTypes1 = [];
      this.allTypes2 = [];
      this.changeTypeRequestForm.controls['type1'].setValue(null);
      this.changeTypeRequestForm.controls['type1'].setValidators([EdpValidators.required]);
      this.changeTypeRequestForm.controls['type1'].updateValueAndValidity();
      this.changeTypeRequestForm.controls['type2'].setValue(null);
      this.changeTypeRequestForm.controls['type2'].setValidators([EdpValidators.required]);
      this.changeTypeRequestForm.controls['type2'].updateValueAndValidity();
      this.initType1List(operation);
      this.checkDefaultValues();
    } else if (field === 'type1') {
      this.allTypes2 = [];
      this.changeTypeRequestForm.controls['type2'].setValue(null);
      this.changeTypeRequestForm.controls['type2'].setValidators([EdpValidators.required]);
      this.changeTypeRequestForm.controls['type2'].updateValueAndValidity();
      this.initType2List(operation);
    } else if (field === 'type2') {
      this.checkDefaultValues();
    }
  }

  changeStatusFunction(value) {
    this.showAttachments = true;
    this.notesLabel = 'Resposta';
    this.notesPlaceholder = 'a sua resposta';
    const res = this.allStatus.find((obj) => {
      return obj.key === value;
    });
    if (res.isInternal) {
      this.showAttachments = false;
      this.notesLabel = 'Notas Internas';
      this.notesPlaceholder = 'a sua nota interna';
    }
    this.checkDefaultValues();
  }

  getRequiredFields(operation) {
    this.requestService.getRequiredFields(operation).subscribe((data) => {
      this.mapRequiredFields(data.Result.Collection);
    });
  }

  getVoltageList() {
    this.requestService.getVoltageLevel().subscribe((voltageResult) => {
      this.voltageLevelList = voltageResult.Result.Collection;
    });
  }

  mapRequiredFields(requiredList) {
    this.dynamicList = requiredList;
    if (requiredList.length > 0) {
      requiredList.forEach((value) => {
        if (value.code === 'voltageLevel') {
          this.changeTypeRequestForm.controls['voltage'].setValidators([EdpValidators.required]);
          this.changeTypeRequestForm.controls['voltage'].updateValueAndValidity();
          this.voltageLevelRequired = true;
          this.showVoltageField = true;
        }
      });
    }
  }

  // FILE FUNCTIONS
  synchronizeFiles(fileList) {
    this.fileList = fileList;
  }

  fileIsInvalid(fileIsInvalid) {
    this.fileTooLarge = fileIsInvalid;
  }

  checkDefaultValues() {
    if (this.changeType) {
      const poBilling = 'pt.edp.request.operation.6';
      const peBilling = 'pt.edp.request.operation.8';
      if (this.changeTypeRequestForm.value.area === poBilling || this.changeTypeRequestForm.value.area === peBilling) {
        this.getVoltageList();
        this.getRequiredFields(this.changeTypeRequestForm.value.area);
      } else {
        this.showVoltageField = false;
      }
    } else if (this.changeStatus) {
      return this.changeStatusRequestForm.value.status === this.defaultStatusId;
    }
  }

  confirmType() {
    this.changeTypeFormData = { event: this.confirmEvent, data: this.changeTypeRequestForm.value };
    this.dialogRef.close(this.changeTypeFormData);
  }

  confirmStatus() {
    this.changeStatusRequestForm.controls['files'].setValue(this.fileList);
    this.changeStatusRequestForm.controls['files'].updateValueAndValidity();
    this.changeStatusFormData = { event: this.confirmEvent, data: this.changeStatusRequestForm.value };
    this.dialogRef.close(this.changeStatusFormData);
  }

  confirmUser() {
    this.changeUserFormData = { event: this.confirmEvent };
    this.dialogRef.close(this.changeUserFormData);
  }

  confirmReOpen() {
    this.reOpenFormData = { event: this.confirmEvent, data: this.reOpenRequestForm.value };
    this.dialogRef.close(this.reOpenFormData);
  }

  close() {
    this.dialogRef.close(this.closeEvent);
  }
}
